import React from "react";

import { Section } from "../../../../App/Common/Styles/containers";
import { ICourseResolveDisplayResponse, IFullCourse } from "../../../../components/course-author/types";
import { ResolveRequestResponse } from "../../../../reducers/course-author/types";
import AssignEditors from "./AssignEditors";
import EditCourseListing from "./EditCourseListing";

interface IEditorListingProps {
  course: IFullCourse;
  courseId: string;
  editors: Array<ResolveRequestResponse<ICourseResolveDisplayResponse>>;
  userId: string;
}

const EditorListing: React.FC<IEditorListingProps> = props => {
  const { course, courseId, userId, editors } = props;
  return (
    <Section>
      <AssignEditors course={course} courseId={courseId} editors={editors} userId={userId} />
      <EditCourseListing course={course} courseId={courseId} userId={userId} />
    </Section>
  );
};

export default EditorListing;
